import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { OptimizationQueueProvider } from './contexts/OptimizationQueueContext';
import './App.css';

// Initialize dark mode on page load (default to dark mode)
if (typeof window !== 'undefined') {
  const savedMode = localStorage.getItem('darkMode');
  const isDarkMode = savedMode === 'false' ? false : true; // Default to dark mode
  document.documentElement.classList.toggle('dark', isDarkMode);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <OptimizationQueueProvider>
        <App />
      </OptimizationQueueProvider>
    </BrowserRouter>
  </React.StrictMode>
);
